import { title } from "../../../../../assets/jss/material-kit-react.jsx"

const workStyle = {
    section: {
        padding: "0 0 70px 0",
    },
    title: {
        ...title,
        marginBottom: "20px",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none",
        textAlign: "center",
        fontWeight: 400,
        color: "rgb(37, 37, 37)",
        fontSize: "2rem",
    },
    description: {
        color: "rgb(128, 128, 128)",
        marginBottom: "50px",
        textAlign: "center",
        fontWeight: "400",
        marginTop: 0,
        fontSize: "1.1rem",
        lineHeight: "1.6",
    },
    textCenter: {
        textAlign: "center",
    },
    button: {
        color: "#222425",
    },
    textArea: {
        marginRight: "15px",
        marginLeft: "15px",
    },
    errorMessage: {
        marginTop: "0px",
        position: "relative",
        top: "-10px",
        left: "4px",
        color: "#f44336",
        fontWeight: 500,
        marginBottom: "2px",
    },
}

export default workStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx